module.exports = __webpack_public_path__ + "img/usa-infectious-diseases-female.edb3c7cf.png";